import React, { useCallback, useEffect, useState } from 'react';
// Types
import { ProductionPackSiteProps } from 'types/productionPackSite';
// Utils
import { delay, useSetState, validArray } from 'utils';
// Packsite Context
import { usePackSiteDispatch, usePackSiteState } from 'context/PackSiteContext';
import * as packsiteFlags from 'context/PackSiteContext/statusFlags';
import { setPackDetailFilters } from 'context/PackSiteContext/actions';
// Assets
import Icon from 'assets/Icon';
// Elements
import Alert from 'elements/Alert';
import Button from 'elements/Button';
import { Loading } from 'elements/Loading'
// Global Components
import PageHeader from 'components/PageHeader';
// Components
import PackSiteData from './components/PackSiteData';
import PackSiteFilterBar from './components/PackSiteFilterBar';
// Styles
import styles from './style/packSitesLog.module.css';
import PackSiteModal from './components/PackSiteModal';


function PackSite() {
  // Event State
  const { packDetailFilters } = usePackSiteState()
  const packSitesDispatch = usePackSiteDispatch();
  const { packSites, packSitesState, noMorePacksites } = usePackSiteState();
  // ModalState
  const initialModalState = {
    active: false,
    packsite: {},
  }
  const [modalState, setModalState] = useSetState(initialModalState);

  // State
  const initialState = {
    loading: true,
    // resendEvents: {},
  }
  const [state, setState] = useSetState(initialState);
  const [disabled, setDisabled] = useState(false);
  

  const loadingData = (
    packSitesState === packsiteFlags.GET_PACK_SITE
      || packSitesState === packsiteFlags.POST_PACK_SITE
  );
  // const packsitePatchSuccess = (
  //   packSitesState === packsiteFlags.POST_PACK_SITE_SUCCESS
  // );

  const initiatePage = useCallback(async () => {
    await delay(200);
    setState({ loading: false });
    // if (packSitesState === packsiteFlags.GET_PACK_SITE_SUCCESS) {
    //   setState({ loading: false });
    // }
  }, [setState]);

  function renderPackSites(packsite:ProductionPackSiteProps) {
    return (
      <PackSiteData
        key={packsite.indexId}
        packsites={packsite}
      />
    )
  }
  
  async function handleNext() {
    setDisabled(true);
    setState({ offSet : Number(state.offSet) + 100 });
    packSitesDispatch(setPackDetailFilters({ ...packDetailFilters, offSet : Number(packDetailFilters.offSet) + 100 }));
  }

  // useEffect(() => {
  //   if (packsitePatchSuccess) {
  //     setState({ resendEvents: {} });
  //   }
  // }, [packsitePatchSuccess, packSitesState, setState]);

  // useEffect(() => {
  //   setState({ resendEvents: {} })
  // }, [packDetailFilters, setState]);

  useEffect(() => {
    initiatePage();
  }, [initiatePage]);

  return (
    <>
      <PageHeader heading="Site Order Fulfilment Tool" />
      <PackSiteFilterBar display={true} setDisabled={setDisabled} />
      <section className="wrapper">
        <div className={`wrapper__content ${styles.container}`}>
          { state.loading || (loadingData && packDetailFilters.offSet === 0) ? (
            <div className={`${styles.loading} ${styles.grid}`}>
              {[...Array(8)].map((e, i) => <span key={i.toString()} />)}
            </div>
          ) : (
            <>
              {(packSites && packSites.length > 0) ? (
                <div className={styles.grid}>
                  {validArray(packSites) && packSites.map(renderPackSites)}
                </div>
              ) : (
                <Alert active={true} type="info" label="No Search matches the text entered" />
              )}
            </>
          )}
        </div> 
      </section>
      <div className="actionFloat">
        <Button
          btnStyle="primary"
          btnType="icon"
          elevation="32-8"
          handler={() => setModalState({
            active: true,
          })}
        >
          <Icon icon="Add" fill="white" size={32} />
        </Button>
      </div>
      <PackSiteModal
        active={modalState.active}
        handleCancel={() => setModalState(initialModalState)}
        packSites={modalState.packsite}
      />
      <div className={styles.seeMore}>
        {disabled ?
          <Button btnStyle="secondary" btnType="icon" label="loading">
            <Loading fill="white" size={32} />
          </Button>
          : null }
        { !disabled && noMorePacksites && packSites.length > 0 ?
          <Button
            btnSize="small"
            btnType="iconBefore"
            elevation="2-4"
            disabled={disabled}
            handler={handleNext}
          >
            <Icon
              icon="ExpandMore"
            />
            See More
          </Button> : null}
      </div>
    </>
  );
}

export default PackSite;
